// extracted by mini-css-extract-plugin
module.exports = {"powerBy":"power-by_powerBy__oaZF4"};